import React from 'react';
import PropTypes from 'prop-types';
import styles from './ArticleStatsRow.module.css';

const ArticleStatsRow = ({
  title,
  visits,
  unlocked,
  paid,
  // ctr,
  // contrib,
}) => (
  <tr className={styles['article-stat-row']}>
    <td className={styles.title}>{title}</td>
    <td className={styles.visits}>{visits}</td>
    <td className={styles.unlocked}>{unlocked}</td>
    <td className={styles.paid}>{paid}</td>
    {/* <td className={styles["ctr"]}>{ctr}</td>
      <td className={styles["contrib"]}>{contrib}</td> */}
  </tr>
);

ArticleStatsRow.propTypes = {
  title: PropTypes.node.isRequired,
  visits: PropTypes.node.isRequired,
  unlocked: PropTypes.node.isRequired,
  paid: PropTypes.node.isRequired,
};

export default ArticleStatsRow;
